import { flow } from 'fp-ts/function';
import { array } from 'fp-ts';
import { Device } from '@mews-commander/legacy-data-structures';
import { reducersFactory, selectorsFactory } from '../factory/reducers';
import { KEY_CUTTERS_FETCH } from '../actions/constants';

export const NAME = 'keyCutters';

const { keyCuttersReducer } = reducersFactory({ name: NAME, baseAction: KEY_CUTTERS_FETCH });
export default keyCuttersReducer;

export const { getKeyCutters, isFetching, getLastUpdated } = selectorsFactory({
    name: NAME,
    entityMapper: array.map(Device),
});

export const hasKeyCutters = flow(getKeyCutters, array.isNonEmpty);
